import SettingTypes from '@/utils/setting-types'

export default {
    name: 'page-params',
    label: {
        title: '页面参数',
        icon: require('@/assets/icon-accessary_PageParams.png')
    },
    sort: 1,
    data: {
        // 页面名称、标题
        page_name: '页面标题',
        // 页面描述
        page_desc: '',
        // 页面类型
        page_type: '',
        //所属企业
        enterprise_id: '',
        // 导航文字颜色
        nav_text_color: '#000000',
        // 导航背景颜色
        nav_background_color: 'rgba(255,255,255,1)',
        // 导航栏样式
        nav_style: 'text',
        // 页面背景样式显示
        show_background_style: false,
        // 页面背景样式
        background_style: 'color',
        // 页面背景图片
        page_background_image: '',
        // 页面背景颜色
        page_background_color: '',
        // 页面标签
        tag: 'MARKETING',
        // 是否显示返回按钮
        is_back_btn: true
    },
    settings: {
        page_name: {
            type: SettingTypes.input,
            label: '页面名称',
            props: {
                placeholder: '请填写页面标题，最多50个字符！',
                maxlength: 50
            }
        },
        page_desc: {
            type: SettingTypes.input,
            label: '页面描述',
            props: {
                type: 'textarea',
                placeholder: '填写页面描述可更好的让人了解你的页面！',
                maxlength: 200
            }
        },
        tag: {
            type: SettingTypes.select,
            label: '页面标签',
            options: [
                { label: '营销页', value: 'MARKETING' },
                { label: '系统配置页', value: 'SYSTEM' }
            ]
        },
        page_type: {
            type: SettingTypes.select,
            label: '页面类型',
            options: [
                { label: '自营', value: 'NORMAL' },
                { label: '京东', value: 'JD' },
                { label: '助农', value: 'ZN' },
                { label: '山姆', value: 'SM' },
                { label: '永辉', value: 'YH' }
            ],
            space_line: true
        },
        // enterprise_id: {
        //   type: SettingTypes.select,
        //   label: '所属企业',
        //   options: [
        //     { label: '企业A', value: '1' },
        //     { label: '企业B', value: '2' }
        //   ]
        // },
        nav_style: {
            type: SettingTypes.radio_button,
            label: '导航栏样式',
            options: [
                { label: '文字导航', value: 'text' },
                { label: '搜索导航', value: 'search-text' }
            ]
        },
        nav_background_color: {
            type: SettingTypes.color_picker,
            label: '导航背景颜色',
            default: 'rgba(255,255,255,1)'
        },
        nav_text_color: {
            type: SettingTypes.radio_button,
            label: '导航文字颜色',
            options: [
                { label: '黑色', value: '#000000' },
                { label: '白色', value: '#ffffff' }
            ]
        },
        show_background_style: {
            type: SettingTypes.boolean,
            label: '页面背景样式',
            props: {
                activeText: '显示',
                inactiveText: '不显示'
            },
            option: {
                key: 'background_style',
                options: [
                    { label: '颜色', value: 'color' },
                    { label: '图片', value: 'image' },
                    { label: '轮播', value: 'swiper' },
                ],
                custom_component_name: 'pageBackgroundImageStyle'
            }
        },
        is_back_btn: {
            type: SettingTypes.boolean,
            label: '是否显示返回按钮',
            props: {
                activeText: '显示',
                inactiveText: '不显示'
            }
        }
    }
}
